import { Trans } from "react-i18next";
import styles from "../LegalIdVerification.module.scss";

/** "We work with IDMe" footer shown under a consumer-branded Legal ID screen. */
export function PartnerFooter() {
  return (
    <p className={styles.partnerFooter}>
      <Trans
        i18nKey="legalId.partnerFooter"
        components={[
          <a
            key="idme-link"
            href="https://id.me"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.partnerFooterLink}
          />
        ]}
      />
    </p>
  );
}
